import { createRoute } from "@tanstack/solid-router";
import { useNavigate } from "@/lib/u-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@/components/ui/page-container";

function AdminEmailPage() {
  const navigate = useNavigate();
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager
        onNew={() => {
          void navigate({ to: "/admin/email/new" });
        }}
        onEdit={(id) => {
          void navigate({ to: "/admin/email/$templateId", params: { templateId: id } });
        }}
      />
    </PageContainer>
  );
}

export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  component: AdminEmailPage,
});
